var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 87C67.5244 87 87 67.5244 87 43.5C87 19.4756 67.5244 0 43.5 0C19.4756 0 0 19.4756 0 43.5C0 67.5244 19.4756 87 43.5 87Z",
    fill: "#5992FF",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3048 27.332C38.9368 27.332 35.4088 29.474 34.1908 32.204C33.1828 34.472 36.5848 36.992 38.6428 34.556C39.7768 33.254 41.3728 32.246 43.0528 32.246C45.9508 32.246 47.6728 33.674 47.6728 36.488C47.6728 39.05 45.2368 41.192 43.0108 42.452C40.7848 43.712 39.5668 45.518 39.5668 48.416V51.272C39.5668 54.254 44.6488 54.086 44.6488 51.272V49.046C44.6488 47.366 45.1108 46.358 46.9168 45.392C50.1508 43.628 53.5108 40.478 53.5108 36.194C53.5108 30.776 49.7308 27.332 43.3048 27.332ZM38.8108 59.756C38.8108 61.52 40.1968 62.906 42.0028 62.906C43.7668 62.906 45.1528 61.52 45.1528 59.756C45.1528 57.992 43.7668 56.564 42.0028 56.564C40.1968 56.564 38.8108 57.992 38.8108 59.756Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_409_717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1887 82.4229L61.6712 64.4632C58.9826 59.4087 59.8564 56.6529 62.0476 55.4968C64.2388 54.3407 66.766 54.9322 69.5352 60.1884L74.2402 69.0741L87.3336 62.1645C90.9901 60.2287 93.598 62.8098 95.6144 65.7672L95.8967 66.2242C98.1485 70.4921 98.6134 75.4796 97.1891 80.0901C95.7649 84.7007 92.5681 88.557 88.3015 90.8113C86.1894 91.9285 83.8779 92.6187 81.499 92.8423C79.1201 93.066 76.7204 92.8187 74.4371 92.1146C72.1538 91.4105 70.0316 90.2634 68.1918 88.7389C66.3519 87.2143 64.8305 85.3422 63.7145 83.2295C63.4694 82.7615 63.3187 82.2499 63.2708 81.7239C63.2957 81.197 63.4378 80.6823 63.6866 80.2172C63.9354 79.7522 64.2848 79.3484 64.7092 79.0353C65.7493 78.2482 66.8663 77.5681 68.0431 77.0054",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1887 82.4229L61.6712 64.4632C58.9826 59.4087 59.8564 56.6529 62.0476 55.4968C64.2388 54.3407 66.766 54.9322 69.5352 60.1884L74.2402 69.0741L87.3336 62.1645C90.9901 60.2287 93.598 62.8098 95.6144 65.7672L95.8967 66.2242C98.1485 70.4921 98.6134 75.4796 97.1891 80.0901C95.7649 84.7007 92.5681 88.557 88.3015 90.8113C86.1894 91.9285 83.8779 92.6187 81.499 92.8423C79.1201 93.066 76.7204 92.8187 74.4371 92.1146C72.1538 91.4105 70.0316 90.2634 68.1918 88.7389C66.3519 87.2143 64.8305 85.3422 63.7145 83.2295C63.4694 82.7615 63.3187 82.2499 63.2708 81.7239C63.2957 81.197 63.4378 80.6823 63.6866 80.2172C63.9354 79.7522 64.2848 79.3484 64.7092 79.0353C65.7493 78.2482 66.8663 77.5681 68.0431 77.0054",
    stroke: "#1C1D1F",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_409_717",
    x: 53.55,
    y: 53.5499,
    width: 44.8999,
    height: 44.8223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_409_717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_409_717",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrescription);
export default __webpack_public_path__ + "static/media/noPrescription.52aff1f0b5b50ed5b34dfdc528529cc6.svg";
export { ForwardRef as ReactComponent };